import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_MhtcmAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_MhtcmAdult' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'>Is hereby certified as meeting all of the following adult mental health targeted case management criteria.</p>
<ol>
    <li>Is enrolled in a Department of Children and Families adult mental health target population</li>
    <li>{`Has a mental health disability (i.e. severe and persistent mental illness) which requires advocacy for and
        coordination of services to maintain or improve level of functioning;`}</li>
    <li>{`Requires services to assist in attaining self sufficiency and satisfaction in the living, learning, work and
        social enviorments of choice.`}</li>
    <li>{`Lacks natural support system with the ability to access needed medical, social, educational and other services;`}</li>
    <li>{`Requires ongoing assistance to access or maintain needed care consistently within the service delivery system;`}</li>
    <li>{`Has a mental health disability (i.e., severe and persistent mental illness) duration that, based upon
        professional judgment, will last for a minimum of one year;`}</li>
    <li>{`Is not recieving duplicate case management services from another provider;`}</li>
    <li>{`Meets at least one of the following requirements (check all that apply):`}</li>
        <ul>
            <li>{`Is awaiting admission to or has been
                discharged from a state mental health treatment facility;`}</li>
            <li>{`Has been discharged from a mental
                health residential treatment facility;`}</li>
            <li>{`Has had more than one admission to a
                crisis stabilization unit (CSU), short-term residential facility (SRT), inpatient psychiatric unit, or any
                combination of these facilities in the past 12 months;`}</li>
            <li>{`Is at risk of institutionalization for
                mental health reasons (Provide explanation below);`}</li>
            <li>{`Is experiencing long-term or acute
                episodes of mental impairment that may put him or her at risk of requiring more intensive services (provide
                explanation below);`}</li>
        </ul>
    
    <li>{`Has relocated from a Department of Children and Families district or region where he or she was
        receiving mental health targeted case management services;`}</li>
</ol>
<p className='w-750'>
    <span className='eleHeader'>Provide Explanation for Items Above</span>
    <textarea id='txt_1' name='txt_1' className='add-only'></textarea>
</p>
<p className='w-750'><h4>Form must be filed in recipient's case record.</h4></p>
<p className='w-750'><span className='small'>{`AHCA-Med Serv Form 030, July 2006 (incorporated by reference in 59G-4.199, F.A.C.`}</span></p>



                
            </div>
        </form>

    )
}











